"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getUTMParameters", {
    enumerable: true,
    get: function() {
        return getUTMParameters;
    }
});
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
var UTMKEYS = [
    "utm_source",
    "utm_campaign",
    "utm_medium",
    "utm_content"
];
var getUTMParameters = function(queryString) {
    var utmParameters = {};
    UTMKEYS.forEach(function(key) {
        utmParameters[key] = "";
    });
    queryString.substring(1) // Remove leading "?"
    .split("&").forEach(function(keyValue) {
        var _keyValue_split = _sliced_to_array._(keyValue.split("="), 2), key = _keyValue_split[0], value = _keyValue_split[1];
        if (UTMKEYS.includes(key)) {
            utmParameters[key] = value;
        }
    });
    return utmParameters;
};

//# sourceMappingURL=uri.js.map